module.exports = __webpack_public_path__ + "img/obras5.e21f0e94.svg";